/* SelectedUserCount.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import EditorInfoPanel from '@atlaskit/icon/glyph/editor/panel';
import { media } from '@atlaskit/primitives';
import { BodySmall, EyebrowSmall } from '@atlassian/mpac-primitives';
import { RichTooltip } from '@atlassian/mpac-ui';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _18 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _17 = "._d0altlke:hover{cursor:pointer}";
const _16 = "._irr3108i:hover{background-color:var(--ds-surface-hovered,#f1f2f4)}";
const _15 = "._8vu41l7b:hover{border-radius:3px}";
const _14 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _13 = "._1bsb1ns9{width:-moz-fit-content;width:fit-content}";
const _12 = "._4cvr1h6o{align-items:center}";
const _11 = "._1o9zn7od{flex-shrink:unset}";
const _10 = "._16jln7od{flex-grow:unset}";
const _9 = "._i0dln7od{flex-basis:unset}";
const _8 = "@media not all and (min-width:48rem){._14adu2gc{margin-bottom:var(--ds-space-100,8px)}}";
const _7 = "._4cvr1y6m{align-items:flex-start}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._i0dlf1ug{flex-basis:0%}";
const _3 = "._1o9zidpf{flex-shrink:0}";
const _2 = "._16jlkb7n{flex-grow:1}";
const _ = "._p12fd60k{max-width:18.75rem}";
const selectedQuantityPanel = null;
const quantityTextContainer = null;
const selectedUserCountStyles = null;
const tooltipContainerStyles = null;
const tooltipDialogContent = null;
export const SelectedUserCount = _ref => {
  let {
    userCount
  } = _ref;
  const tooltipContent = /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_p12fd60k"]),
      children: /*#__PURE__*/_jsx(BodySmall, {
        children: "Number of users billed for the app"
      })
    })]
  });
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_16jlkb7n _1o9zidpf _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1y6m _14adu2gc"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_9, _10, _11]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_i0dln7od _16jln7od _1o9zn7od"]),
          children: /*#__PURE__*/_jsx(RichTooltip, {
            content: tooltipContent,
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_5, _12, _13, _14, _15, _16, _17]
              }), /*#__PURE__*/_jsxs(EyebrowSmall, {
                className: ax(["_1e0c1txw _4cvr1h6o _1bsb1ns9 _syaz131l _8vu41l7b _irr3108i _d0altlke"]),
                children: ["QUANTITY", /*#__PURE__*/_jsx(EditorInfoPanel, {
                  label: "Number of users selected"
                })]
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_18]
        }), /*#__PURE__*/_jsx(BodySmall, {
          className: ax(["_18s8ze3t"]),
          children: userCount
        })]
      })]
    })]
  });
};